import React, { useEffect, useState } from "react";
import axios from "axios";
import TableComponent from "../components/TableComponent";
import { Container, Button } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import { formatDate, formatActive } from "../utils/helpers";
const API_URL = process.env.REACT_APP_API_URL;



function List_data_entry() {

    const [data_entry, setDataEntry] = useState([]);
    const navigate = useNavigate();


    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;

        axios.get(`${API_URL}/data_entry_list`, { headers: { Authorization: `Bearer ${token}` } })
            .then(res => setDataEntry(res.data.data_entry || []))
            .catch(err => console.error(err));
    }, []);

    const handleEdit = (id) => navigate(`/Edit_data_entry/${id}`);

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure?")) return;

        const token = localStorage.getItem("token");

        try {
            const res = await axios.delete(`${API_URL}/data_entry_delete/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (res.data.status) {
                setDataEntry(data_entry.filter(u => u.data_id !== id));

                alert(res.data.message);
            } else {
                alert(res.data.message || res.data.error || "Failed to delete");
            }
        } catch (err) {
            console.error(err);
            alert("An error occurred while deleting the record");
        }
    };








    const columns = [
        { key: "index", label: "Sr.no", format: (_, __, index) => index + 1 },
        { key: "data_heading", label: "Data Heading", align: "left" },
        { key: "created_date", label: "Created Date", format: formatDate },
        {
            key: "action",
            label: "Action",
            format: (_, row) => (
                <>
                    <Button size="sm" className="me-2" onClick={() => handleEdit(row.data_id)}>Edit</Button>
                    <Button size="sm" variant="danger" onClick={() => handleDelete(row.data_id)}>Delete</Button>
                </>
            )
        }
    ];










    return (
        <Container className="mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Data Entry List</h3>

                <Link className="btn btn-sm btn-primary" to="/data-entry">Add New Data</Link>

            </div>
            <TableComponent columns={columns} data={data_entry} rowsPerPage={10} maxHeight={400} headerClass="table-dark" />

        </Container>

    );
}

export default List_data_entry;